import React from "react";
import { AiOutlineCamera } from "react-icons/ai";
import ErrorInputComponent from "./ErrorInputComponent";

export default function ImageUploadComponent({
  onImageUpload,
  imageDetails,
  imageError,
}) {
  return (
    <>
      <div>
        {imageDetails?.imagePreview !== "" ? (
          <div className="">
            <div className="flex items-center justify-center">
              <label className="cursor-pointer flex flex-col h-full w-full p-2 rounded-md border border-green-800 border-dashed hover:bg-gray-100 hover:border-gray-300">
                <img
                  className="h-full w-full"
                  src={imageDetails?.imagePreview}
                />
                <input
                  type="file"
                  className="opacity-0"
                  onChange={(e) => onImageUpload(e)}
                  name="image"
                />
              </label>
            </div>
          </div>
        ) : (
          <div className="doc_processing_colo">
            <div className="flex items-center justify-center">
              <label className="cursor-pointer flex flex-col h-24 w-full p-2 rounded-md border border-green-800 border-dashed hover:bg-gray-100 hover:border-gray-300">
                <div className="flex flex-col items-center justify-center p-2">
                  <AiOutlineCamera size={25} color="green" />
                  <div className="text-xs text-center text-green-800">
                    Add an image
                  </div>
                </div>
                <input
                  type="file"
                  className="opacity-0"
                  onChange={(e) => onImageUpload(e)}
                  name="image"
                />
              </label>
            </div>
          </div>
        )}
      </div>
      <ErrorInputComponent error={imageError} />
    </>
  );
}
